import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { subscribeAuthState } from "../services/authService";
import { logError } from "../utils/logger";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = subscribeAuthState(
      (currentUser) => {
        setUser(currentUser || null);
        setAuthLoading(false);
      },
      (error) => {
        logError("AuthProvider", "Auth state listener failed", error);
        setUser(null);
        setAuthLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  const value = useMemo(
    () => ({
      user,
      authLoading
    }),
    [user, authLoading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
}
